import { useEffect } from "react";
import { trackEvent } from "../../../utils/Matomo/matomo";

export function GlobalClickTracker() {
  useEffect(() => {
    function handleClick(event: MouseEvent) {
      const target = event.target as HTMLElement;
      const tagName = target.tagName.toLowerCase();

      if (tagName === "button" || tagName === "a") {
        const elementName = target.innerText || target.getAttribute("aria-label") || "Unknown";
        trackEvent("User Interaction", "Click", elementName);
      }
    }

    document.addEventListener("click", handleClick);
    return () => {
      document.removeEventListener("click", handleClick);
    };
  }, []);

  return null; // Kein UI-Element, nur für das Tracking
}

